module.exports = __webpack_public_path__ + "static/img/wzx.2ebfa2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/wzx.png
// module id = vhDJ
// module chunks = 43